require("./src/data/styles.css");

exports.onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined") return;

  const page_path = location?.pathname || window.location?.pathname || "/";

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "page_view",
    page_path,
  });
};
